import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { id: "form" }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-6 gap-3 p-4 mt-6 border rounded md:gap-6 border-neutral-100"
}
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 pb-3 border-t border-gray-200 md:pb-0" }, null, -1)
const _hoisted_6 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-3 md:flex md:space-x-6" }
const _hoisted_9 = { class: "shrink-0 sm:pt-[26px] pt-3 sm:col-span-1 col-span-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Check", -1)
const _hoisted_11 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode(" Sex "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1)
const _hoisted_13 = { class: "flex items-center pt-2 space-x-6 sm:pt-5" }
const _hoisted_14 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, "Gender", -1)
const _hoisted_16 = { class: "flex items-center pt-3 space-x-6 sm:pt-5" }
const _hoisted_17 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_18 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_19 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_20 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_21 = {
  key: 1,
  class: "grid grid-cols-6 gap-3 p-4 mt-6 border rounded md:gap-6 border-neutral-100"
}
const _hoisted_22 = { class: "col-span-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 pb-3 border-t border-gray-200 md:pb-0" }, null, -1)
const _hoisted_24 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_25 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_26 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_27 = { class: "flex flex-col space-y-3 sm:flex-row sm:space-x-6 sm:space-y-0 space-between" }
const _hoisted_28 = { class: "w-full sm:py-6" }
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, "Reabuse?", -1)
const _hoisted_31 = { class: "flex items-center pt-3 space-x-6 sm:pt-5" }
const _hoisted_32 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, " Timing of Incident ", -1)
const _hoisted_34 = { class: "flex items-center pt-3 space-x-6 sm:pt-5" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "block col-span-6 my-3 border-t border-gray-100 sm:hidden" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 pb-3 sm:pb-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Diagnosis")
], -1)
const _hoisted_37 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_38 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_39 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_40 = { class: "flex flex-col space-y-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold sm:mb-5 text-neutral-600" }, "Comorbid VAC/VAW ", -1)
const _hoisted_42 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_43 = { class: "flex flex-col space-y-3 sm:space-y-6" }
const _hoisted_44 = { class: "flex flex-col space-y-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-3 text-xs font-semibold sm:mb-5 sm:mt-0 text-neutral-600" }, "Mental Health Diagnosis ", -1)
const _hoisted_46 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_47 = { class: "flex items-center my-6 space-x-6" }
const _hoisted_48 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600",
  id: "email-error"
}
const _hoisted_49 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "block col-span-6 my-3 border-t border-gray-100 sm:hidden" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 pb-3 sm:pb-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Referral & Services")
], -1)
const _hoisted_52 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_53 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_54 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_55 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_56 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_57 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_58 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_59 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_60 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_61 = {
  key: 0,
  class: "col-span-6 md:col-span-2 sm:col-span-3"
}
const _hoisted_62 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_63 = { class: "col-span-6 md:col-span-2 sm:col-span-3" }
const _hoisted_64 = {
  key: 2,
  class: "grid items-start grid-cols-6 p-4 mt-6 border rounded md:gap-6 border-neutral-100"
}
const _hoisted_65 = { class: "col-span-6 mb-6 md:mb-0" }
const _hoisted_66 = { class: "grid grid-cols-3 col-span-6 md:col-span-3 gap-y-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Date Registered")
], -1)
const _hoisted_68 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Full Name")
], -1)
const _hoisted_70 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Sex")
], -1)
const _hoisted_72 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100 md:pb-0 md:border-b-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Gender")
], -1)
const _hoisted_74 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100 md:pb-0 md:border-b-0" }
const _hoisted_75 = { class: "grid grid-cols-3 col-span-6 mt-3 md:col-span-3 gap-y-3 md:mt-0" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Birthdate")
], -1)
const _hoisted_77 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_78 = { class: "col-span-1 pb-2 border-b border-gray-100" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Indigeneous People?")
], -1)
const _hoisted_83 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "PWD?")
], -1)
const _hoisted_85 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_86 = {
  key: 0,
  class: "col-span-1"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Specify", -1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { class: "col-span-2 pl-3" }
const _hoisted_90 = {
  key: 3,
  class: "grid items-start grid-cols-6 p-4 mt-6 border rounded md:gap-6 border-neutral-100"
}
const _hoisted_91 = { class: "col-span-6 mb-6 md:mb-0" }
const _hoisted_92 = { class: "grid grid-cols-3 col-span-6 md:col-span-3 gap-y-3" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Case Number")
], -1)
const _hoisted_94 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Date Initiated")
], -1)
const _hoisted_96 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100 md:pb-0 md:border-b-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Reabused")
], -1)
const _hoisted_98 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100 md:pb-0 md:border-b-0" }
const _hoisted_99 = { class: "grid grid-cols-3 col-span-6 md:col-span-3 gap-y-3" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Old Patient")
], -1)
const _hoisted_101 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100 md:pb-0 md:border-b-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Timing of Incident")
], -1)
const _hoisted_103 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100 md:pb-0 md:border-b-0" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 my-6 md:my-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Diagnosis")
], -1)
const _hoisted_105 = { class: "grid grid-cols-3 col-span-6 md:col-span-3 gap-y-3" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Primary Diagnosis")
], -1)
const _hoisted_107 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Comorbid VAC/VAW")
], -1)
const _hoisted_109 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Other Diagnosis")
], -1)
const _hoisted_111 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Mental Health Diagnosis")
], -1)
const _hoisted_113 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100 md:pb-0 md:border-b-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Specify")
], -1)
const _hoisted_115 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100 md:pb-0 md:border-b-0" }
const _hoisted_116 = { class: "grid grid-cols-3 col-span-6 mt-3 md:col-span-3 gap-y-3 md:mt-0" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Suicidal Risk")
], -1)
const _hoisted_118 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Subcategory")
], -1)
const _hoisted_120 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Subcategory 2")
], -1)
const _hoisted_122 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 md:pb-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "HAMA")
], -1)
const _hoisted_124 = { class: "col-span-2 pb-2 pl-3 md:pb-0" }
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-100" }, null, -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 my-6 md:my-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Referral & Services")
], -1)
const _hoisted_129 = { class: "grid grid-cols-3 col-span-6 md:col-span-3 gap-y-3" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Referral Source")
], -1)
const _hoisted_131 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Specify")
], -1)
const _hoisted_133 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Second Referral Source")
], -1)
const _hoisted_135 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Services Sought")
], -1)
const _hoisted_137 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Assigned Physician")
], -1)
const _hoisted_139 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100 md:pb-0 md:border-b-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Assigned Mental Health Personnel")
], -1)
const _hoisted_141 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100 md:pb-0 md:border-b-0" }
const _hoisted_142 = { class: "grid grid-cols-3 col-span-6 mt-3 md:col-span-3 gap-y-3 md:mt-0" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Intake Social Worker")
], -1)
const _hoisted_144 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Assigned Social Worker")
], -1)
const _hoisted_146 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Assigned Medical Social Service (MSS)")
], -1)
const _hoisted_148 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Trainee")
], -1)
const _hoisted_150 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Endorsed to")
], -1)
const _hoisted_152 = { class: "col-span-2 pl-3" }
const _hoisted_153 = {
  key: 4,
  class: "grid items-start grid-cols-6 p-4 mt-6 border rounded md:gap-6 border-neutral-100"
}
const _hoisted_154 = { class: "col-span-6 mb-6 md:mb-0" }
const _hoisted_155 = { class: "grid grid-cols-3 col-span-6 md:col-span-3 gap-y-3" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Inpatient?")
], -1)
const _hoisted_157 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Hospital Area")
], -1)
const _hoisted_159 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Hospital Number")
], -1)
const _hoisted_161 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "If Applicable, indicate child is")
], -1)
const _hoisted_163 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Educational Attainment")
], -1)
const _hoisted_165 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Nationality")
], -1)
const _hoisted_167 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100 md:pb-0 md:border-b-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Internally displaced?")
], -1)
const _hoisted_169 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100 md:pb-0 md:border-b-0" }
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { key: 1 }
const _hoisted_172 = { class: "grid grid-cols-3 col-span-6 mt-3 md:col-span-3 gap-y-3 md:mt-0" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Civil Status")
], -1)
const _hoisted_174 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Religion")
], -1)
const _hoisted_176 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_177 = { key: 0 }
const _hoisted_178 = { key: 1 }
const _hoisted_179 = { key: 2 }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Employment Status")
], -1)
const _hoisted_181 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "If Employed, Company/School Name")
], -1)
const _hoisted_183 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Company/School Contact Number")
], -1)
const _hoisted_185 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Company/School Address")
], -1)
const _hoisted_187 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_188 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Remarks")
], -1)
const _hoisted_189 = { class: "col-span-2 pl-3" }
const _hoisted_190 = {
  key: 5,
  class: "grid grid-cols-6 gap-3 p-4 mt-6 border rounded md:gap-6 border-neutral-100"
}
const _hoisted_191 = {
  class: "col-span-6",
  id: "other_details"
}
const _hoisted_192 = { class: "col-span-6 lg:col-span-3" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, "Inpatient?", -1)
const _hoisted_194 = { class: "flex items-center pt-3 space-x-6 sm:pt-5" }
const _hoisted_195 = { class: "flex flex-col mt-3 space-y-3 sm:space-x-6 sm:space-y-0 sm:flex-row" }
const _hoisted_196 = { class: "w-full sm:w-1/2" }
const _hoisted_197 = { class: "w-full sm:w-1/2" }
const _hoisted_198 = { class: "self-end col-span-6 lg:col-span-3 sm:pb-3" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, "Is Internally displaced?", -1)
const _hoisted_200 = { class: "flex items-center pt-3 space-x-6 sm:pt-5" }
const _hoisted_201 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_202 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_203 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_204 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_205 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_206 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_207 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_208 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_209 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_210 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_211 = { class: "col-span-6" }
const _hoisted_212 = { class: "col-span-6" }
const _hoisted_213 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2 text-xs font-semibold text-neutral-600" }, "Remarks", -1)
const _hoisted_214 = { class: "flex flex-col mb-6 space-y-3" }
const _hoisted_215 = ["onClick"]
const _hoisted_216 = /*#__PURE__*/_createElementVNode("span", null, "Add Remarks", -1)
const _hoisted_217 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_218 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_219 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_220 = { class: "flex items-center justify-center mx-auto" }

import { ref, computed, onMounted, type PropType, watch} from "vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import CheckModal from "./Components/CheckModal.vue";
import { PlusIcon, TrashIcon } from "@heroicons/vue/24/outline";
import DataTable from "@/components/partials/DataTable.vue";
import GoToButton from "@/components/buttons/GoToButton.vue";
import { renderSelect, renderSelectV2 } from "@/interfaces/DropdownInterface";
import { useRoute } from "vue-router";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import PatientService from "@/classes/PatientService";
import { useNetworkStore } from "@/store/network";
import { CreatePatient } from "@/interfaces/PatientInterface";

import UserBirthdateAge from '@/components/forms/UserBirthdateAge.vue'

import { BirthdayClassification } from "@/views/enums/BirthdayClassification";
import { numberonly } from "@/components/composables/useNumberOnly";
import SearchTwoIcon from "@/components/icons/searchTwoIcon.vue";
import PatientRecordService from "@/classes/Patients/PatientRecordService";
 
/**
 * VARIABLES
 */
interface itemsInterface {
	id: number;
	last_name: string;
	first_name: string;
	middle_name: string;
	nickname: string;
	birthdate: string;
	created_at_formatted: string;
	abbr: string;
	gender_meta: object;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
	newRecord: {
		type: Boolean,
		default: true,
	},
	form: {
		type: Object as PropType<CreatePatient>,
		required: true,
	},
	additionalData: {
		type: Object,
		required: true,
	},
	errors: {
		type: Object,
		required: true,
	},
	item: {
		type: Object,
	},
},
  emits: ['update:form'],
  setup(__props, { emit: __emit }) {

const route = useRoute();
const props = __props;

const emit = __emit;

const form = ref<CreatePatient>(props.form);
const showCheck = ref<boolean>(false);
const createNewPatient = ref<boolean>(route.params.patient ? false : true);
const headers: { text: string }[] = [{ text: "Patient Name" }, { text: "Latest Case No." }];
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const items = ref<itemsInterface[]>([]);
const biologicalGenderOptions = computed<renderSelectV2[]>(() => props.additionalData?.sexAtBirth || []);
const genderOptions = computed<renderSelectV2[]>(() => props.additionalData?.genders || []);
const reabuseOptions = [
	{ id: "1", label: "Yes", value: 1 },
	{ id: "0", label: "No", value: 0 },
];
const timeIncidentOptions = computed<renderSelectV2[]>(() => props.additionalData?.incidentTimes || []);
const primaryDiagnosisOptions = computed<renderSelect[]>(() => props.additionalData?.primaryDiagnoses || []);
const conductDisorderOptions = computed<renderSelectV2[]>(() => props.additionalData?.behaviors || []);
const highSuicidalOptions = computed<renderSelect[]>(() => props.additionalData?.highSuicidalRisks || []);
const endorsedToOptions = computed<renderSelect[]>(() => props.additionalData?.endorsedToOptions || []);


const inpatientOptions = [
	{ id: "1", label: "Yes", value: 1 },
	{ id: "0", label: "No", value: 0 },
];

const internalDisplacedOptions = [
	{ id: "1", label: "Yes", value: 1 },
	{ id: "0", label: "No", value: 0 },
];
const pwdOptions = computed<renderSelect[]>(() => props.additionalData?.pwds || []);
const referralSourceOptions = computed<renderSelect[]>(() => props.additionalData?.referralSources || []);
const serviceSoughtOptions = computed<renderSelect[]>(() => props.additionalData?.soughtServices || []);
const socialWorkerOptions = computed<renderSelect[]>(() => props.additionalData?.socialWorkers || []);
const assignedPhysicianOptions = computed<renderSelect[]>(() => props.additionalData?.physicians || []);
const assignedPsychiatristOptions = computed<renderSelect[]>(() => props.additionalData?.psychiatrists || []);
const mmsOptions = computed<renderSelect[]>(() => props.additionalData?.mms || []);
const traineeOptions = computed<renderSelect[]>(() => props.additionalData?.trainees || []);
const comorbiditiesOptions = computed<renderSelect[]>(() => props.additionalData?.comorbidities || []);
const mentalHealthOptions = computed<renderSelect[]>(() => props.additionalData?.mentalHealthDiagnoses || []);
const behaviorTypeOptions = computed<renderSelect[]>(
	() =>
		props.additionalData?.behaviorTypes.filter((item) => {
			if (item.type == getSelectedBehavior.value) {
				return item;
			}
		}) || []
);
const civilStatusOptions = computed<renderSelect[]>(() => props.additionalData?.civilStatuses || []);
const nationalityOptions = computed<renderSelect[]>(() => props.additionalData?.nationalities || []);
const religionOptions = computed<renderSelect[]>(() => props.additionalData?.religions || []);
const childTypeOptions = computed<renderSelect[]>(() => props.additionalData?.childTypes || []);
const hospitalAreaOptions = computed<renderSelect[]>(() => props.additionalData?.hospitalAreas || []);
const educationAttainmentOptions = computed<renderSelect[]>(() => props.additionalData?.educationalAttainments || []);
const employmentStatusOptions = computed<renderSelect[]>(() => props.additionalData?.employmentStatuses || []);
const indigeneousOptions = computed<renderSelect[]>(() => props.additionalData?.indigeneous || []);
const hasRadioButtonId = computed<number>(() => props.additionalData?.mentalHealthStaticRadioButtonId);
const getSelectedBehavior = computed<number | null>(
	() =>
		form.value.mental_health.filter((item) => {
			if (item.type?.toString()) {
				return item;
			}
		})[0]?.type
);

const isNone = ref(7) // if Is PWD = None
const isPwd = ref<boolean>(false) // if Is PWD = None
const isOtherIndigeneous = ref<boolean>(false) // if Is PWD = None

const updateFormComorbidity = (index: number, isChecked: boolean, data: object): void => {
	if (isChecked) {
		form.value.comorbidities[index]["comorbidity_id"] = data.id;
	}
	if (!isChecked) {
		form.value.comorbidities[index] = {
			comorbidity_id: null,
			checked: false,
		};
	}
};


const inMetalHealth = (id:number):boolean =>{
	const index = getMetalHealthIndex(id)
	return index > -1;
}

const updateMentalHealth = (isChecked: boolean, data: object): void => {
	const index = getMetalHealthIndex(data.id)

	if (index == -1) {
		form.value.mental_health.push({
			'specify': '',
			'type': '',
			'behavior_type_id': '',
			'mental_health_diagnoses_id': data.id,
		});
	} else {
		form.value.mental_health.splice(index, 1);
	}
};

const getMetalHealthIndex = (id:number):number => {
	return form.value.mental_health.map((item) => item?.mental_health_diagnoses_id).indexOf(id);
}

const addRemarks = () => {
	form.value.remarks.push({ remarks: null });
};

const removeRemarks = (index: number) => {
	form.value.remarks = form.value.remarks.filter((item, itemIndex) => itemIndex != index);
};

const maxDate = () => {
    // Convert to Date object
    const date = new Date();

    // Set the time to 11:59:59.999 (end of the day)
    date.setHours(23, 59, 59, 999);
    return date;
};

const checkPatient = () => {
	PatientRecordService.search(
		{
			last_name: form.value.last_name,
			first_name: form.value.first_name,
			birthdate: form.value.birthdate,
			mode: 'patient',
			rows: 20,
		},
        isNetworkAvailable.value
	)
		.then((response: any) => {
			showCheck.value = true;
            items.value = response.data.items.data;
		})
		.catch((error) => {
			showCheck.value = false;
			console.log(error);
		});
};

const scrollToOtherDetails = ():void => {
	if(route?.query?.other_details){
		const element = document.getElementById('other_details')
			
		element.scrollIntoView({
			behavior: "smooth",
			inline: "start",
		});
	}
}

const enablePWDSpecify = () => {
    if (form.value.pwd && form.value.pwd != isNone.value) {
        isPwd.value = true;
    } else {
        isPwd.value = false;
    }
}

const disabledReferralSourceOther = (id: number) => {
    return referralSourceOptions.value.find((item: any) => item.id == id && (item.label === 'Others' || item.label === 'others')) != undefined ? false : true;
}

const checkOthers = () => {
    if (form.value.other_indigeneous_people) {
        form.value.indigeneous_people_id = 'others';
    }

    if (form.value.other_nationality) {
        form.value.nationality_id = 'others';
    }

    if (form.value.other_religion) {
        form.value.religion_id = 'others';
    }
}

watch(
	() => form.value.pwd,
	(val) => { 
		if(val != isNone.value){
			isPwd.value = true; 
		} else {
			isPwd.value = false;
			form.value.pwd_specify = null
		} 
	}
); 

watch(
	() => form.value.indigeneous_people_id,
	(val: any) => {
		if(val != 'others' || val == 'None'){
			isOtherIndigeneous.value = false;
			form.value.other_indigeneous_people = null
		} else {
			isOtherIndigeneous.value = true;
		}
	}
); 

watch(
    form.value,
    () => {
        emit('update:form', form.value);
    }
);

watch(
    () => form.value.is_inpatient,
    (val) => {
        if (!val) {
            form.value.hospital_area_id = null;
            form.value.hospital_number = null;
        }
    }
);

watch(
    () => form.value.hospital_area_id,
    (val) => {
        if (!val) {
            form.value.hospital_number = null;
        }
    }
);

watch(
    () => form.value.referral_source_id,
    (val) => {
        if (disabledReferralSourceOther(val)) {
            form.value.referral_specify = null;
        }
    }
);

watch(
	() => form.value.nationality_id,
	(val: any) => {
		if(val != 'others'){
			form.value.other_nationality = null
		}
	}
); 

watch(
	() => form.value.religion_id,
	(val: any) => {
		if(val != 'others'){
			form.value.other_religion = null
		}
	}
); 
 
onMounted(() => {
    checkOthers();
	if( route.params.case && form.value.religion_id == false && form.value.other_religion){
		form.value.religion_id = 'others'
	}

    if (form.value.indigeneous_people_id == 'others') {
        isOtherIndigeneous.value = true;
    }

	if(form.value.indigeneous_people_id === 0) { 
		form.value.indigeneous_people_id = 'none';
	}

    enablePWDSpecify();
	scrollToOtherDetails(); 
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      (__props.newRecord)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(SectionTitle, {
                fontSmall: "",
                title: "Patient Information"
              })
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(DatePicker, {
                id: "registered_at",
                name: "patient_registered",
                label: "Date & Time Registered",
                required: "",
                modelValue: form.value.registered_at,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.registered_at) = $event)),
                error: __props.errors?.registered_at,
                enableTimePicker: true,
                timePickerInline: true,
                maxDate: maxDate()
              }, null, 8, ["modelValue", "error", "maxDate"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(TextInput, {
                  class: "col-span-2 sm:col-span-1",
                  type: "text",
                  label: "Last Name",
                  placeholder: "Last name",
                  name: "last_name",
                  id: "last_name",
                  required: "",
                  modelValue: form.value.last_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.last_name) = $event)),
                  error: __props.errors?.last_name
                }, null, 8, ["modelValue", "error"]),
                _createVNode(TextInput, {
                  class: "col-span-2 sm:col-span-1",
                  type: "text",
                  label: "First Name",
                  placeholder: "First name",
                  name: "first_name",
                  id: "first_name",
                  required: "",
                  modelValue: form.value.first_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.first_name) = $event)),
                  error: __props.errors?.first_name
                }, null, 8, ["modelValue", "error"]),
                _createVNode(TextInput, {
                  class: "col-span-2 sm:col-span-1",
                  type: "text",
                  label: "Middle Name",
                  placeholder: "Middle name",
                  name: "middle_name",
                  id: "middle_name",
                  modelValue: form.value.middle_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.middle_name) = $event)),
                  error: __props.errors?.middle_name
                }, null, 8, ["modelValue", "error"]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(ButtonComponent, {
                    size: "large",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (checkPatient())),
                    disabled: !form.value.last_name && !form.value.first_name,
                    customClass: "primary sm:w-auto w-full"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _createVNode(SearchTwoIcon, { class: "object-contain w-5 h-5 ml-1 icon" })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(RadioGroup, {
                  id: "sex_at_birth",
                  options: biologicalGenderOptions.value,
                  name: "bioGender",
                  required: "",
                  modelValue: form.value.sex_at_birth,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.sex_at_birth) = $event)),
                  error: __props.errors?.sex_at_birth
                }, null, 8, ["options", "modelValue", "error"])
              ]),
              (__props.errors?.sex_at_birth)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(["text-[10px] mt-1", __props.errors?.sex_at_birth ? 'text-red-600' : 'text-gray-800']),
                    id: "email-error"
                  }, _toDisplayString(__props.errors?.sex_at_birth), 3))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(RadioGroup, {
                  options: genderOptions.value,
                  name: "gender",
                  id: "gender",
                  modelValue: form.value.gender,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.gender) = $event)),
                  error: __props.errors?.gender
                }, null, 8, ["options", "modelValue", "error"])
              ]),
              (__props.errors?.gender)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(["text-[10px] mt-1", __props.errors?.gender ? 'text-red-600' : 'text-gray-800']),
                    id: "email-error"
                  }, _toDisplayString(__props.errors?.gender), 3))
                : _createCommentVNode("", true)
            ]),
            _createVNode(UserBirthdateAge, {
              form: form.value,
              errors: __props.errors,
              customClass: "sm:col-span-3 col-span-6"
            }, null, 8, ["form", "errors"]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(MultiSelect, {
                options: pwdOptions.value,
                label: "Is PWD?",
                id: "pwd",
                name: "pwd_status",
                placeholder: "Select..",
                modelValue: form.value.pwd,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.pwd) = $event)),
                error: __props.errors?.pwd,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(TextInput, {
                type: "text",
                placeholder: "Specify",
                id: "pwd_specify",
                name: "pwdMentalDisability",
                label: "Specify",
                modelValue: form.value.pwd_specify,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.pwd_specify) = $event)),
                error: __props.errors?.pwd_specify,
                disabled: form.value.pwd == isNone.value || form.value.pwd == null
              }, null, 8, ["modelValue", "error", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(MultiSelect, {
                options: indigeneousOptions.value,
                searchable: "",
                id: "indigeneous_people_id",
                name: "ethnicity",
                label: "Indigenous Group",
                placeholder: "Select..",
                modelValue: form.value.indigeneous_people_id,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.indigeneous_people_id) = $event)),
                error: __props.errors?.indigeneous_people_id
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(TextInput, {
                type: "text",
                label: "Specify",
                placeholder: "Specify",
                name: "ethnicity_others",
                id: "other_indigeneous_people",
                disabled: !isOtherIndigeneous.value,
                modelValue: form.value.other_indigeneous_people,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.other_indigeneous_people) = $event)),
                error: __props.errors?.other_indigeneous_people
              }, null, 8, ["disabled", "modelValue", "error"])
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.newRecord)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(SectionTitle, {
                fontSmall: "",
                title: "Case Details"
              })
            ]),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createVNode(TextInput, {
                type: "text",
                label: "Case Number",
                placeholder: "Case Number(system generated)",
                name: "case_number",
                id: "case_number",
                disabled: true,
                modelValue: form.value.case_number,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.case_number) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(DatePicker, {
                id: "initiated_at",
                name: "date_initiated",
                label: "Date Initiated",
                modelValue: form.value.initiated_at,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.initiated_at) = $event)),
                error: __props.errors?.initiated_at,
                maxDate: maxDate
              }, null, 8, ["modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(CheckboxInput, {
                    checked: form.value.is_followup,
                    id: "is_followup",
                    name: "follow_up_case",
                    label: "Old Patient",
                    modelValue: form.value.is_followup,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.is_followup) = $event)),
                    error: __props.errors?.is_followup
                  }, null, 8, ["checked", "modelValue", "error"]),
                  (__props.errors?.is_followup)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(["text-[10px] mt-1", __props.errors?.is_followup ? 'text-red-600' : 'text-gray-800']),
                        id: "email-error"
                      }, _toDisplayString(__props.errors?.is_followup), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(RadioGroup, {
                      options: reabuseOptions,
                      name: "reabuse",
                      id: "is_reabuse",
                      modelValue: form.value.is_reabuse,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.is_reabuse) = $event)),
                      error: __props.errors?.is_reabuse
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  (__props.errors?.is_reabuse)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(["text-[10px] mt-1", __props.errors?.is_reabuse ? 'text-red-600' : 'text-gray-800']),
                        id: "email-error"
                      }, _toDisplayString(__props.errors?.is_reabuse), 3))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createVNode(RadioGroup, {
                  options: timeIncidentOptions.value,
                  name: "timeIncident",
                  id: "incident_time",
                  modelValue: form.value.incident_time,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.incident_time) = $event)),
                  error: __props.errors?.incident_time,
                  required: ""
                }, null, 8, ["options", "modelValue", "error"])
              ]),
              (__props.errors?.incident_time)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(["text-[10px] mt-1", __props.errors?.incident_time ? 'text-red-600' : 'text-gray-800']),
                    id: "email-error"
                  }, _toDisplayString(__props.errors?.incident_time), 3))
                : _createCommentVNode("", true)
            ]),
            _hoisted_35,
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createVNode(MultiSelect, {
                options: primaryDiagnosisOptions.value,
                label: "Primary Diagnosis",
                id: "primary_diagnosis",
                name: "primary_diagnosis",
                placeholder: "Select..",
                searchable: "",
                modelValue: form.value.primary_diagnoses_id,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.primary_diagnoses_id) = $event)),
                error: __props.errors?.primary_diagnoses_id
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(TextInput, {
                type: "text",
                label: "Other Diagnosis",
                placeholder: "Other Diagnosis",
                name: "other_diagnosis",
                id: "other_diagnoses",
                modelValue: form.value.other_diagnoses,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.other_diagnoses) = $event)),
                error: __props.errors?.other_diagnoses
              }, null, 8, ["modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comorbiditiesOptions.value, (comorbidity, index) => {
                  return (_openBlock(), _createBlock(CheckboxInput, {
                    key: comorbidity,
                    checked: form.value.comorbidities[index]['checked'],
                    id: 'comorbidity' + index,
                    name: 'comorbidity' + index,
                    label: comorbidity.value,
                    "onUpdate:modelValue": (value) => updateFormComorbidity(index, value, comorbidity)
                  }, null, 8, ["checked", "id", "name", "label", "onUpdate:modelValue"]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mentalHealthOptions.value, (mentalHealth, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: mentalHealth }, [
                      _createVNode(CheckboxInput, {
                        checked: inMetalHealth(mentalHealth.id),
                        id: `mental_health.${mentalHealth.id}.specify` ,
                        name: 'mentalHealth' + index,
                        label: mentalHealth.label,
                        "onUpdate:modelValue": 
											(value) => updateMentalHealth(value, mentalHealth)
										
                      }, null, 8, ["checked", "id", "name", "label", "onUpdate:modelValue"]),
                      (inMetalHealth(mentalHealth.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createVNode(TextInput, {
                              id: `mental_health.${getMetalHealthIndex(mentalHealth.id)}.specify`,
                              type: "text",
                              placeholder: "Specify",
                              name: "neurodevelopmental_disorders_specific",
                              modelValue: form.value.mental_health[getMetalHealthIndex(mentalHealth.id)]['specify'],
                              "onUpdate:modelValue": ($event: any) => ((form.value.mental_health[getMetalHealthIndex(mentalHealth.id)]['specify']) = $event),
                              error: __props.errors[`mental_health.${getMetalHealthIndex(mentalHealth.id)}.specify`]
                            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "error"]),
                            (mentalHealth.id == hasRadioButtonId.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _createVNode(RadioGroup, {
                                      id: `mental_health.${getMetalHealthIndex(mentalHealth.id)}.type`,
                                      options: conductDisorderOptions.value,
                                      name: "conductDisorder",
                                      modelValue: form.value.mental_health[getMetalHealthIndex(mentalHealth.id)]['type'],
                                      "onUpdate:modelValue": ($event: any) => ((form.value.mental_health[getMetalHealthIndex(mentalHealth.id)]['type']) = $event)
                                    }, null, 8, ["id", "options", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  (__props.errors[`mental_health.${getMetalHealthIndex(mentalHealth.id)}.type`])
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(__props.errors[`mental_health.${getMetalHealthIndex(mentalHealth.id)}.type`]), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(MultiSelect, {
                                    options: behaviorTypeOptions.value,
                                    id: `mental_health.${getMetalHealthIndex(mentalHealth.id)}.behavior_type_id`,
                                    name: "suicidalBehavior",
                                    placeholder: "Select..",
                                    searchable: "",
                                    modelValue: form.value.mental_health[getMetalHealthIndex(mentalHealth.id)]['behavior_type_id'],
                                    "onUpdate:modelValue": ($event: any) => ((form.value.mental_health[getMetalHealthIndex(mentalHealth.id)]['behavior_type_id']) = $event),
                                    error: __props.errors[`mental_health.${getMetalHealthIndex(mentalHealth.id)}.behavior_type_id`]
                                  }, null, 8, ["options", "id", "modelValue", "onUpdate:modelValue", "error"])
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(MultiSelect, {
                    options: highSuicidalOptions.value,
                    label: "Suicidal Risk",
                    id: "high_suicidal_risk",
                    name: "suicidal_risk",
                    placeholder: "Select..",
                    modelValue: form.value.high_suicidal_risk,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.high_suicidal_risk) = $event)),
                    error: __props.errors?.high_suicidal_risk,
                    searchable: ""
                  }, null, 8, ["options", "modelValue", "error"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(CheckboxInput, {
                    id: "is_hama",
                    name: "hama",
                    label: "Home Against Medical Advice (HAMA)",
                    checked: form.value.is_hama,
                    modelValue: form.value.is_hama,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.is_hama) = $event)),
                    error: __props.errors?.is_hama
                  }, null, 8, ["checked", "modelValue", "error"])
                ])
              ])
            ]),
            _hoisted_50,
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _createVNode(MultiSelect, {
                options: referralSourceOptions.value,
                id: "referral_source_id",
                name: "referral_source",
                label: "Referral Source",
                placeholder: "Select..",
                searchable: "",
                required: "",
                modelValue: form.value.referral_source_id,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.referral_source_id) = $event)),
                error: __props.errors?.referral_source_id
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createVNode(TextInput, {
                type: "text",
                label: "Specify",
                placeholder: "Specify",
                name: "referral_source_others",
                id: "referral_source_id",
                modelValue: form.value.referral_specify,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.referral_specify) = $event)),
                disabled: disabledReferralSourceOther(form.value.referral_source_id)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createVNode(MultiSelect, {
                options: referralSourceOptions.value,
                id: "second_referral_source_id",
                name: "second_referral_source",
                label: "Second Referral Source",
                placeholder: "Select..",
                searchable: "",
                modelValue: form.value.second_referral_source_id,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.value.second_referral_source_id) = $event)),
                error: __props.errors?.second_referral_source_id
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createVNode(MultiSelect, {
                options: serviceSoughtOptions.value,
                id: "sought_service_id",
                name: "service_sought",
                label: "Services Sought",
                placeholder: "Select..",
                searchable: "",
                required: "",
                modelValue: form.value.sought_service_id,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.value.sought_service_id) = $event)),
                error: __props.errors?.sought_service_id
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(MultiSelect, {
                options: socialWorkerOptions.value,
                id: "intake_social_worker_id",
                name: "intake_social_worker",
                label: "Intake Social Worker",
                placeholder: "Select..",
                searchable: "",
                modelValue: form.value.intake_social_worker_id,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((form.value.intake_social_worker_id) = $event)),
                error: __props.errors?.intake_social_worker_id
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createVNode(MultiSelect, {
                options: socialWorkerOptions.value,
                id: "social_worker_id",
                name: "assigned_social_worker",
                label: "Assigned Social Worker",
                placeholder: "Select..",
                modelValue: form.value.social_worker_id,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((form.value.social_worker_id) = $event)),
                error: __props.errors?.social_worker_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createVNode(TextInput, {
                label: "Assigned Medical Social Service (MSS)",
                placeholder: "Assigned Medical Social Service (MSS)",
                name: "assigned_mss",
                id: "assigned_mss",
                modelValue: form.value.assigned_mss,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((form.value.assigned_mss) = $event)),
                error: __props.errors?.assigned_mss
              }, null, 8, ["modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createVNode(MultiSelect, {
                options: assignedPhysicianOptions.value,
                id: "physician_id",
                name: "assigned_physician",
                label: "Assigned Physician",
                placeholder: "Select..",
                modelValue: form.value.physician_id,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((form.value.physician_id) = $event)),
                error: __props.errors?.physician_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createVNode(MultiSelect, {
                options: assignedPsychiatristOptions.value,
                id: "mental_health_personnel_id",
                name: "assigned_mental_health_personnel",
                label: "Assigned Mental Health Personnel",
                placeholder: "Select..",
                modelValue: form.value.mental_health_personnel_id,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((form.value.mental_health_personnel_id) = $event)),
                error: __props.errors?.mental_health_personnel_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            (!__props.newRecord)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createVNode(MultiSelect, {
                    options: mmsOptions.value,
                    id: "mms_id",
                    name: "assigned_mms",
                    label: "Assigned MMS",
                    placeholder: "Select..",
                    modelValue: form.value.mms_id,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((form.value.mms_id) = $event)),
                    error: __props.errors?.mms_id,
                    searchable: ""
                  }, null, 8, ["options", "modelValue", "error"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_62, [
              _createVNode(MultiSelect, {
                options: traineeOptions.value,
                id: "trainee_id",
                name: "trainee",
                label: "Trainee",
                placeholder: "Select..",
                modelValue: form.value.trainee_id,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((form.value.trainee_id) = $event)),
                error: __props.errors?.trainee_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createVNode(MultiSelect, {
                options: endorsedToOptions.value,
                id: "endorsed_to_id",
                name: "endorsed_to",
                label: "Endorsed to",
                placeholder: "Select..",
                modelValue: form.value.endorsed_to_id,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((form.value.endorsed_to_id) = $event)),
                error: __props.errors?.endorsed_to_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ])
          ]))
        : _createCommentVNode("", true),
      (!__props.newRecord)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createVNode(SectionTitle, { title: "Patient Details" })
            ]),
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("p", null, _toDisplayString(__props.additionalData?.patient?.registered_at_formatted || __props.item?.registered_at_formatted), 1)
              ]),
              _hoisted_69,
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.name), 1)
              ]),
              _hoisted_71,
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("p", null, _toDisplayString(__props.additionalData?.patient?.sex_at_birth_meta?.description ||
								__props.item?.sex_at_birth_meta?.description), 1)
              ]),
              _hoisted_73,
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.gender_meta?.description), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.patient?.birthdate_formatted || __props.item?.birthdate || "Unknown"), 1)
              ]),
              _createElementVNode("div", _hoisted_78, [
                (_unref(BirthdayClassification).APPROXIMATE_AGE == __props.item?.birthday_classification)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_79, " Approximate Age "))
                  : (_openBlock(), _createElementBlock("p", _hoisted_80, " Age "))
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.computed_age) + "  ", 1)
              ]),
              _hoisted_82,
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.other_indigeneous_people || __props.item?.indigeneous?.name), 1)
              ]),
              _hoisted_84,
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.pwd_meta?.description), 1)
              ]),
              (__props.item?.pwd_specify)
                ? (_openBlock(), _createElementBlock("div", _hoisted_86, _hoisted_88))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.pwd_specify), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!__props.newRecord)
        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createVNode(SectionTitle, { title: "Case Details" })
            ]),
            _createElementVNode("div", _hoisted_92, [
              _hoisted_93,
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.case_number || "Offline(No Case Number)"), 1)
              ]),
              _hoisted_95,
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.initiated_at_formatted), 1)
              ]),
              _hoisted_97,
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.is_reabuse ? "Yes" : "No"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_99, [
              _hoisted_100,
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.is_followup ? "Yes" : "No"), 1)
              ]),
              _hoisted_102,
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.incident_time_meta?.description), 1)
              ])
            ]),
            _hoisted_104,
            _createElementVNode("div", _hoisted_105, [
              _hoisted_106,
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.diagnoses?.primary_diagnoses?.name), 1)
              ]),
              _hoisted_108,
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.comorbidities
									?.filter((item) => {
										if (item.id) {
											return item;
										}
									})
									?.map((item) => item?.name)
									?.toString()), 1)
              ]),
              _hoisted_110,
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.diagnoses?.other_diagnoses), 1)
              ]),
              _hoisted_112,
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.mental_health_diagnoses?.map((item) => item?.mental_health?.name)?.toString()), 1)
              ]),
              _hoisted_114,
              _createElementVNode("div", _hoisted_115, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.mental_health_diagnoses?.map((item) => item?.specify)?.toString()), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_116, [
              _hoisted_117,
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.diagnoses?.high_suicidal_risk_meta?.description), 1)
              ]),
              _hoisted_119,
              _createElementVNode("div", _hoisted_120, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.mental_health_diagnoses
									?.filter((item) => {
										if (typeof item.type_meta?.description == 'string') {
											return item;
										}
									})
									.map((item) => item?.type_meta?.description)
									.toString()), 1)
              ]),
              _hoisted_121,
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.mental_health_diagnoses
									?.filter((item) => {
										if (typeof item?.behavior_type?.name == 'string') {
											return item;
										}
									})
									.map((item) => item?.behavior_type?.name)
									.toString()), 1)
              ]),
              _hoisted_123,
              _createElementVNode("div", _hoisted_124, [
                (__props.item?.diagnoses?.is_hama)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_125, _toDisplayString(__props.item?.diagnoses?.is_hama ? 'Yes' : 'No'), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_126, " - "))
              ])
            ]),
            _hoisted_127,
            _hoisted_128,
            _createElementVNode("div", _hoisted_129, [
              _hoisted_130,
              _createElementVNode("div", _hoisted_131, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.referral_service?.referral_source?.name), 1)
              ]),
              _hoisted_132,
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.referral_service?.referral_specify ?? '-'), 1)
              ]),
              _hoisted_134,
              _createElementVNode("div", _hoisted_135, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.referral_service?.second_referral_source?.name), 1)
              ]),
              _hoisted_136,
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.referral_service?.sought_service?.name), 1)
              ]),
              _hoisted_138,
              _createElementVNode("div", _hoisted_139, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.referral_service?.physician?.name), 1)
              ]),
              _hoisted_140,
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.referral_service?.mental_health_personnel?.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_142, [
              _hoisted_143,
              _createElementVNode("div", _hoisted_144, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.referral_service?.intake_social_worker?.name), 1)
              ]),
              _hoisted_145,
              _createElementVNode("div", _hoisted_146, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.referral_service?.social_worker?.name), 1)
              ]),
              _hoisted_147,
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.assigned_mss), 1)
              ]),
              _hoisted_149,
              _createElementVNode("div", _hoisted_150, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.referral_service?.trainee?.name), 1)
              ]),
              _hoisted_151,
              _createElementVNode("div", _hoisted_152, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.endorsed_to?.name || ''), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!__props.newRecord)
        ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
            _createElementVNode("div", _hoisted_154, [
              _createVNode(SectionTitle, { title: "Other Details" })
            ]),
            _createElementVNode("div", _hoisted_155, [
              _hoisted_156,
              _createElementVNode("div", _hoisted_157, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.is_inpatient ? "Yes" : "No"), 1)
              ]),
              _hoisted_158,
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.hospital_area?.name), 1)
              ]),
              _hoisted_160,
              _createElementVNode("div", _hoisted_161, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.hospital_number), 1)
              ]),
              _hoisted_162,
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.child_type_meta?.description), 1)
              ]),
              _hoisted_164,
              _createElementVNode("div", _hoisted_165, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.educational_attainment?.name), 1)
              ]),
              _hoisted_166,
              _createElementVNode("div", _hoisted_167, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.other_nationality || __props.item?.nationality?.name), 1)
              ]),
              _hoisted_168,
              _createElementVNode("div", _hoisted_169, [
                (__props.item?.is_internally_displaced)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_170, _toDisplayString(__props.item?.is_internally_displaced ? "Yes" : "No"), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_171, " - "))
              ])
            ]),
            _createElementVNode("div", _hoisted_172, [
              _hoisted_173,
              _createElementVNode("div", _hoisted_174, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.civil_status?.name), 1)
              ]),
              _hoisted_175,
              _createElementVNode("div", _hoisted_176, [
                (__props.item?.other_religion)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_177, _toDisplayString(__props.item?.other_religion), 1))
                  : (__props.item?.religion?.name)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_178, _toDisplayString(__props.item?.religion?.name), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_179, "-"))
              ]),
              _hoisted_180,
              _createElementVNode("div", _hoisted_181, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.employment_status?.name), 1)
              ]),
              _hoisted_182,
              _createElementVNode("div", _hoisted_183, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.company_name), 1)
              ]),
              _hoisted_184,
              _createElementVNode("div", _hoisted_185, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.company_contact_number), 1)
              ]),
              _hoisted_186,
              _createElementVNode("div", _hoisted_187, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.company_address), 1)
              ]),
              _hoisted_188,
              _createElementVNode("div", _hoisted_189, [
                _createElementVNode("p", null, _toDisplayString(__props.item?.remarks?.map((item) => item?.remarks)?.toString()), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.newRecord && !createNewPatient.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
            _createElementVNode("div", _hoisted_191, [
              _createVNode(SectionTitle, {
                fontSmall: "",
                title: "Other Details"
              })
            ]),
            _createElementVNode("div", _hoisted_192, [
              _hoisted_193,
              _createElementVNode("div", _hoisted_194, [
                _createVNode(RadioGroup, {
                  options: inpatientOptions,
                  name: "inpatientStatus",
                  id: "is_inpatient",
                  modelValue: form.value.is_inpatient,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((form.value.is_inpatient) = $event)),
                  error: __props.errors?.is_inpatient
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_195, [
                _createElementVNode("div", _hoisted_196, [
                  _createVNode(MultiSelect, {
                    options: hospitalAreaOptions.value,
                    id: "hospital_area_id",
                    name: "inpatient_status",
                    placeholder: "Select Hospital Area",
                    modelValue: form.value.hospital_area_id,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((form.value.hospital_area_id) = $event)),
                    error: __props.errors?.hospital_area_id,
                    searchable: ""
                  }, null, 8, ["options", "modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_197, [
                  _createVNode(TextInput, {
                    type: "text",
                    placeholder: "Hospital Number",
                    name: "company_name",
                    id: "hospital_number",
                    modelValue: form.value.hospital_number,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((form.value.hospital_number) = $event)),
                    error: __props.errors?.hospital_number
                  }, null, 8, ["modelValue", "error"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_198, [
              _hoisted_199,
              _createElementVNode("div", _hoisted_200, [
                _createVNode(RadioGroup, {
                  options: internalDisplacedOptions,
                  name: "internalDisplaced",
                  id: "is_internally_displaced",
                  modelValue: form.value.is_internally_displaced,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((form.value.is_internally_displaced) = $event)),
                  error: __props.errors?.is_internally_displaced
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_201, [
              _createVNode(MultiSelect, {
                options: childTypeOptions.value,
                id: "child_status",
                name: "child_status",
                label: "If Applicable, indicate child is",
                placeholder: "Select..",
                modelValue: form.value.child_type,
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((form.value.child_type) = $event)),
                error: __props.errors?.child_type,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_202, [
              _createVNode(MultiSelect, {
                options: civilStatusOptions.value,
                id: "civil_status_id",
                name: "civil_status",
                label: "Civil Status",
                placeholder: "Select..",
                modelValue: form.value.civil_status_id,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((form.value.civil_status_id) = $event)),
                error: __props.errors?.civil_status_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_203, [
              _createVNode(MultiSelect, {
                options: nationalityOptions.value,
                id: "nationality_id",
                name: "nationality",
                label: "Nationality",
                placeholder: "Select..",
                modelValue: form.value.nationality_id,
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((form.value.nationality_id) = $event)),
                error: __props.errors?.nationality_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_204, [
              _createVNode(TextInput, {
                type: "text",
                label: "Other nationality",
                placeholder: "Other nationality",
                name: "other_ethnicity",
                id: "other_nationality",
                modelValue: form.value.other_nationality,
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((form.value.other_nationality) = $event)),
                disabled: form.value.nationality_id == 'others' ? false : true,
                error: __props.errors?.other_nationality
              }, null, 8, ["modelValue", "disabled", "error"])
            ]),
            _createElementVNode("div", _hoisted_205, [
              _createVNode(MultiSelect, {
                options: religionOptions.value,
                id: "religion",
                name: "religion",
                label: "Religion",
                placeholder: "Select..",
                modelValue: form.value.religion_id,
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((form.value.religion_id) = $event)),
                error: __props.errors?.religion_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_206, [
              _createVNode(TextInput, {
                type: "text",
                label: "Other religion",
                placeholder: "Other religion",
                name: "other_religion",
                id: "other_religion",
                disabled: form.value.religion_id == 'others' ? false : true,
                modelValue: form.value.other_religion,
                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((form.value.other_religion) = $event)),
                error: __props.errors?.other_religion
              }, null, 8, ["disabled", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_207, [
              _createVNode(MultiSelect, {
                options: educationAttainmentOptions.value,
                id: "educational_attainment_id",
                name: "educational_attainment",
                label: "Educational Attainment",
                placeholder: "Select..",
                modelValue: form.value.educational_attainment_id,
                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((form.value.educational_attainment_id) = $event)),
                error: __props.errors?.educational_attainment_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_208, [
              _createVNode(MultiSelect, {
                options: employmentStatusOptions.value,
                id: "employment_status_id",
                name: "employment_status",
                label: "Employment Status",
                placeholder: "Select..",
                modelValue: form.value.employment_status_id,
                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((form.value.employment_status_id) = $event)),
                error: __props.errors?.employment_status_id,
                searchable: ""
              }, null, 8, ["options", "modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_209, [
              _createVNode(TextInput, {
                type: "text",
                label: "Company/School Name",
                placeholder: "Company/School name",
                name: "company_name",
                id: "company_name",
                modelValue: form.value.company_name,
                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((form.value.company_name) = $event)),
                error: __props.errors?.company_name
              }, null, 8, ["modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_210, [
              _createVNode(TextInput, {
                type: "tel",
                label: "Company/School Contact Number",
                placeholder: "Company/School contact number",
                name: "company_contact_number",
                id: "company_contact_number",
                add_on_left: true,
                add_on_text: "+63",
                maxlength: 10,
                modelValue: form.value.company_contact_number,
                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((form.value.company_contact_number) = $event)),
                error: __props.errors.company_contact_number,
                onKeypress: _unref(numberonly)
              }, null, 8, ["modelValue", "error", "onKeypress"])
            ]),
            _createElementVNode("div", _hoisted_211, [
              _createVNode(TextInput, {
                textarea: "",
                label: "Company/School Address",
                placeholder: "Company/School address",
                name: "company_address",
                id: "company_address",
                modelValue: form.value.company_address,
                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((form.value.company_address) = $event)),
                error: __props.errors?.company_address
              }, null, 8, ["modelValue", "error"])
            ]),
            _createElementVNode("div", _hoisted_212, [
              _hoisted_213,
              _createElementVNode("div", _hoisted_214, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.remarks, (remark, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "relative",
                    key: remark
                  }, [
                    _createVNode(TextInput, {
                      textarea: "",
                      placeholder: "Remarks",
                      name: "remarks",
                      id: "remarks",
                      modelValue: form.value.remarks[index]['remarks'],
                      "onUpdate:modelValue": ($event: any) => ((form.value.remarks[index]['remarks']) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (removeRemarks(index)),
                      type: "button",
                      class: "absolute top-0 right-0 z-10 p-1 cursor-pointer",
                      title: "Delete this remark"
                    }, [
                      _createVNode(_unref(TrashIcon), { class: "w-5 h-5 text-red-600 hover:text-red-700" })
                    ], 8, _hoisted_215)
                  ]))
                }), 128))
              ]),
              _createVNode(ButtonComponent, {
                customClass: "secondary md:w-auto w-full",
                onClick: _cache[47] || (_cache[47] = ($event: any) => (addRemarks()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                  _hoisted_216
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(CheckModal, {
      show: showCheck.value,
      onConfirm: _cache[48] || (_cache[48] = ($event: any) => (showCheck.value = false)),
      "action-text": "Cancel",
      title:  items.value.length > 0 ? 'Name Matched!' : 'No Record Found',
      description: "Relevant data and other details"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(DataTable, {
            headers: headers,
            "no-action": false,
            count: items.value.length
          }, {
            body: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createElementBlock("tr", { key: item }, [
                  _createElementVNode("td", _hoisted_217, _toDisplayString(item.first_name) + " " + _toDisplayString(item.last_name), 1),
                  _createElementVNode("td", _hoisted_218, _toDisplayString(item.latest_case_number), 1),
                  _createElementVNode("td", _hoisted_219, [
                    _createElementVNode("div", _hoisted_220, [
                      _createVNode(GoToButton, {
                        routeLink: `/patient/${item.patient_id || item.offline_id}/view`
                      }, null, 8, ["routeLink"])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["count"])
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ]))
}
}

})